<template>
  <div>
    <div class="asc-apu-cycle-export">
      <div class="asc-apu-cycle-export-options--container">
        <div class="asc-apu-cycle-export-options">
          <asc-date-picker
            v-model="date"
            class="asc-child-options"
            icon-position="right"
            has-icon
            label="Date"
            @input="handleInput()"
          ></asc-date-picker>
          <div class="asc-empty-div"></div>
          <asc-autocomplete-selector
            v-model="airlineIds"
            :items="airlinesData"
            label="Airline"
            class="asc-child-options"
            placeholder="Select Airline"
            :component-type="airlinesData.length > 1 ? 'multiple' : 'single'"
            dense
            drop-down-size-matches
            required
            fixed-position
            short
            @input="handleInput()"
          ></asc-autocomplete-selector>
          <div class="asc-empty-div"></div>
          <asc-autocomplete-selector
            v-model="masterModelNames"
            :items="masterModelsData"
            label="Platform"
            class="asc-child-options"
            placeholder="Select Platform"
            component-type="multiple"
            dense
            drop-down-size-matches
            required
            fixed-position
            short
            use-strings
            @input="handleInput()"
          ></asc-autocomplete-selector>
          <div class="asc-empty-div"></div>
        </div>

        <asc-note class="asc-report-note">
          <v-icon class="asc-report-note--icon" :size="12" color="#C98703"
            >mdi-alert</v-icon
          >
          <span class="asc-report-note--text"
            >Note: Selected options will influence the amount of exported data
            and the time to generate the export.</span
          >
        </asc-note>
      </div>
    </div>
  </div>
</template>

<script>
import AscDatePicker from '@/components/atoms/AscDatePicker'
import AscNote from '@/components/atoms/AscNote'
import AscAutocompleteSelector from './AscAutocompleteSelector'

export default {
  name: 'AscApuCycleExport',

  components: {
    AscDatePicker,
    AscAutocompleteSelector,
    AscNote,
  },

  props: {
    value: {
      type: Object,
      default: null,
    },
    airlines: {
      type: Array,
      default: () => [],
    },
    masterModels: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      airlineIds:
        this.value && this.value.airlineIds
          ? this.value.airlineIds
          : this.airlines?.length === 1
          ? [this.airlines[0].value]
          : [],
      masterModelNames:
        this.value && this.value.masterModelNames
          ? this.value.masterModelNames
          : [],
      date: this.value && this.value.date ? this.value.date : new Date(),
    }
  },

  computed: {
    airlinesData() {
      return this.airlines
    },
    masterModelsData() {
      if (this.airlineIds.length) {
        return this.masterModels.filter(item =>
          this.airlineIds.includes(item.airlineId),
        )
      }
      return this.masterModels
    },
  },

  mounted() {
    this.handleInput()
  },

  methods: {
    handleInput() {
      const data = {
        date: this.date ? this.date : new Date(),
        airlineIds: this.airlineIds,
        masterModelNames: this.masterModelNames,
      }
      this.$emit('input', data)
    },
  },
}
</script>

<style lang="scss">
.asc-apu-cycle-export {
  padding: 20px 10px;

  & .asc-report-note {
    &.asc-note--container {
      background-color: $semantic-warning-hover;
    }

    & .asc-note {
      display: flex;
    }

    &--icon {
      align-self: flex-start;
      padding: 6px 3px;
    }

    &--text {
      color: $primary-black;
      font-size: 12px;
      padding: 3px;
    }
  }

  & .asc-empty-div {
    height: 30px;
  }

  .asc-datepicker-input--container {
    padding-top: 10px;
  }
}
</style>
